export interface ParametersFormContext {
  rootId?: string
  layer?: 'account' | 'user'
  setFieldUploading?: (fieldId: string, uploading: boolean) => void
}

export const layerFromFormContext = (formContext: unknown): 'account' | 'user' => {
  if (formContext && typeof formContext === 'object' && 'layer' in formContext) {
    const value = (formContext as { layer?: unknown }).layer
    if (value === 'account' || value === 'user') {
      return value
    }
  }
  return 'user'
}

const noopSetFieldUploading = () => {}

export const setFieldUploadingFromFormContext = (formContext: unknown): ((fieldId: string, uploading: boolean) => void) => {
  if (formContext && typeof formContext === 'object' && 'setFieldUploading' in formContext) {
    const value = (formContext as { setFieldUploading?: unknown }).setFieldUploading
    if (typeof value === 'function') {
      return value as (fieldId: string, uploading: boolean) => void
    }
  }
  return noopSetFieldUploading
}
